var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-list"},[_c('h2',{staticClass:"title"},[_vm._v("模板管理")]),_c('bk-list',{ref:"list",attrs:{"search-config":_vm.searchConfig,"button-config":_vm.buttonConfig,"table-config":_vm.tableConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }